import { Runtime } from '@/core/enums/runtime.enum'

import { getSourceRepository } from './gcgNaming/builders'
import { normalizeGraftConfigEnvSegment } from './normalizeGraftConfigEnvSegment'

export const buildGraftConfigEnvVarName = (
  sourceRuntime: Runtime | undefined,
  libraryName: string,
  libraryNamespace?: string
): string => {
  const repository = normalizeGraftConfigEnvSegment(getSourceRepository(sourceRuntime))
  const trimmedNamespace = libraryNamespace?.trim()
  const packageIdentity = trimmedNamespace ? `${trimmedNamespace}|${libraryName}` : libraryName
  const packageSegment = normalizeGraftConfigEnvSegment(packageIdentity)

  return `GRAFTCODE_CONFIG_${repository}_${packageSegment}`
}
